import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  removeSiteGatewaySuccessAction
} from '../../reducers/actions';
import { GatewayService } from '../../services';
import { apiErrorHandling } from '../../utils/epics/apiErrorHandling';
import updateErrorMsgAction from '../../reducers/error-banner/actions/updateErrorMsg';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_SITE_GATEWAY),
    switchMap(action =>
      GatewayService.deleteSiteGateway(
        action.siteId,
        action.nodeAddress,
        store
      ).pipe(
        map(() => removeSiteGatewaySuccessAction(action.nodeAddress)),
        catchError(apiErrorHandling(updateErrorMsgAction))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/deleteSiteGateway.js